import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// We'll reuse the review page CSS for the form
import './FacultyDetailPage.css'; 

const AddFacultyPage = () => {
  const [name, setName] = useState('');
  const [department, setDepartment] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !department) {
      setError('Please fill in both name and department.');
      return;
    }
    setSubmitting(true);
    setError('');

    try {
      const newFaculty = { name, department };
      // Post to the new route we just made
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; // Fallback for local dev
        const res = await axios.post(`${apiUrl}/api/faculty`, newFaculty);      
      // On success, redirect to the new faculty's page
      navigate(`/faculty/${res.data._id}`);

    } catch (err) {
      setSubmitting(false);
      setError(err.response.data.message || 'Failed to add faculty');
    }
  };

  return (
    // We reuse the styling from the review form
    <div className="faculty-detail-container" style={{ maxWidth: '600px' }}>
      <div className="review-form-card">
        <h4>Add a New Faculty Member</h4>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Faculty Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="review-input"
              placeholder="e.g., Dr. XYZ"
            />
          </div>
          <div className="form-group">
            <label>Department</label>
            <input
              type="text"
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
              className="review-input"
              placeholder="e.g., Computer Science & Engineering"
            />
          </div>
          
          {error && <p style={{ color: 'red', fontSize: '0.9rem' }}>{error}</p>}

          <button type="submit" className="btn-submit-review" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Add Faculty'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddFacultyPage;